/**
 * Main file for all Navbar styles
 * 
 * @author Creator-Solutions -> Owen Burns
 */

import styled from 'styled-components';

const NavOuterContainer = styled.div`
   width: 100vw;
   height: 8vh;
   position: fixed;
   z-index: 1001;
`

export {
   NavOuterContainer
}